import { imageProfileGenerator } from "../../../../utils/image/imageProfileGenerator";
import { GalleryImageObject } from "../../utils";
import { ZoomableImage } from "./ZoomableImage";
import styles from "./GalleryImageElement.module.scss";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";

type GalleryImageElementProps = {
  mediaItem: GalleryImageObject;
  isSelected: boolean;
  index: number;
  sizes?: string;
  fullscreen?: boolean;
  hasSuperZoom?: boolean;
  usePrefetching?: boolean;
};

export const GalleryImageElement = ({
  fullscreen,
  mediaItem,
  isSelected,
  index,
  hasSuperZoom,
  sizes,
  usePrefetching,
}: GalleryImageElementProps) =>
  fullscreen ? (
    <ZoomableImage
      mediaItem={mediaItem}
      isSelected={isSelected}
      dataTestId={`carousel-image-${index}`}
      className={styles.galleryImage}
      loading={index > 0 ? "lazy" : "eager"}
      hasSuperZoom={hasSuperZoom}
    />
  ) : (
    <img
      src={formatAmplienceImageURL(mediaItem.imageUrl)}
      alt=""
      data-testid={`carousel-image-${index}`}
      className={styles["galleryImage"]}
      sizes={sizes}
      srcSet={imageProfileGenerator(mediaItem.imageUrl)}
      loading={index > 0 ? "lazy" : "eager"}
      fetchPriority={index == 0 && usePrefetching ? "high" : "auto"}
    />
  );
